module.exports = __webpack_public_path__ + "static/manufacturing_final-f96a11c1b1bb30a93a3c54eec312527a.png";